import { GuidService } from 'ui-components/services/guid-service';
import { ALL_ORDERS_PAGE_VIEWS, ORDER_ALERTS_ID } from '../pages/orders-page/orders-page-view-constants';

class OrdersGridViewServiceClass {
  isValidViewId(viewId) {
    return ALL_ORDERS_PAGE_VIEWS.map((view) => view.id).filter((id) => id === viewId).length > 0;
  }

  getRouteFilter() {
    return `(${ALL_ORDERS_PAGE_VIEWS.map((view) => view.id).join('|')})`;
  }

  viewShouldRefreshAlertsGrid(viewId) {
    return viewId === ORDER_ALERTS_ID;
  }

  findStoreGuidFromStatusMatch(viewId) {
    const match = GuidService.getGuidRegexMatch(viewId);
    if (!match) {
      return;
    }
    return match[0];
  }
}

export const OrdersGridViewService = new OrdersGridViewServiceClass();
